import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-marker",
  "use": "icon-marker-usage",
  "viewBox": "0 0 15 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" id=\"icon-marker\"><path fill-rule=\"evenodd\" d=\"M0 7.103C0 3.2 3.21 0 7.122 0s7.121 3.2 7.12 7.103c0 1.115-.257 2.316-.803 3.302l-.003.006-5.096 8.673-.016.021c-.295.4-.607.76-1.115.81-.55.056-.982-.356-1.291-.759l-.02-.025-4.61-7.971A7.04 7.04 0 0 1 0 7.103M7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol